import { Group, Box, UnstyledButton } from "@mantine/core";
import { Link, useLocation } from "@remix-run/react";
import { Maybe } from "graphql/jsutils/Maybe";

import { Module, Permission } from "~/graphql/__generated__/types";
import { cn } from "~/lib/tw";

type LinksGroupProps = {
  module: Maybe<Module>;
  child: Permission[];
};

export function LinksGroup({ module, child }: LinksGroupProps) {
  const location = useLocation();

  const hasLinks = Array.isArray(child) && child.length > 0;

  function isPathnameMatch(link: Maybe<string>) {
    if (!link) return false;
    return location.pathname === link && location.pathname.includes(link);
  }

  return (
    <>
      {(hasLinks ? child : []).map((link, idx) => {
        if (link.canAccess && link.canRead) {
          return (
            <Link
              // @ts-expect-error path might be null
              to={link.module?.path}
              key={`menu-${link.module?.path}-${idx}`}
              prefetch="none"
            >
              <UnstyledButton
                className={cn(
                  "w-full font-medium block no-underline !px-4 !py-[0.625rem] text-sm text-[var(--mantine-color-text)] rounded-lg",
                  isPathnameMatch(link.module?.path)
                    ? "!text-white !bg-tm-blue-600"
                    : "hover:!text-[var(--mantine-color-black)] hover:!bg-tm-gray-200",
                )}
              >
                <Group justify="space-between" gap={0}>
                  <Box style={{ display: "flex", alignItems: "center" }}>
                    <Box ml={0}>{link.module?.name}</Box>
                  </Box>
                </Group>
              </UnstyledButton>
            </Link>
          );
        }

        return null;
      })}
      {!hasLinks && module ? (
        <Link
          // @ts-expect-error path might be null
          to={module.path}
          key={`menu-module-${module.path}-${module.id}`}
          prefetch="none"
        >
          <UnstyledButton
            className={cn(
              "w-full font-medium block no-underline !px-4 !py-[0.625rem] text-sm text-[var(--mantine-color-text)] rounded-lg",
              isPathnameMatch(module.path)
                ? "!text-white !bg-tm-blue-600"
                : "hover:!text-[var(--mantine-color-black)] hover:!bg-tm-gray-200",
            )}
          >
            <Group justify="space-between" gap={0}>
              <Box style={{ display: "flex", alignItems: "center" }}>
                <Box ml={0}>{module.name}</Box>
              </Box>
            </Group>
          </UnstyledButton>
        </Link>
      ) : null}
    </>
  );
}
